import { Injectable } from '@angular/core';
import { LocalNotifications } from '@capacitor/local-notifications';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() {
    this.scheduleComeBackMessages();
  }


  async create(id: number, message: string, data: string, when: Date) {

    // Don't schedule past notifications
    const now = new Date().valueOf();
    if (now > when.valueOf()) {
      return;
    }

    try {
      // Check if user allows us to
      if (localStorage.getItem('disableLocal') === '1') {
        console.log('Did not create local notification because user disabled option.', message);
      } else {
        if (LocalNotifications != null) {
          const notifs = await LocalNotifications.schedule({
            notifications: [
              {
                title: 'BidBeacon',
                body: message,
                id: id,
                schedule: { at: when },
                sound: null,
                attachments: null,
                actionTypeId: "",
                extra: data
              }
            ]
          });
          // console.log('scheduled notifications', notifs);
        } else {
          console.error('Local notifications are null');
        }
      }
    } catch (err) {
      console.error('Error scheduling notification', err);
    }
  }

  async clearAll() {
    try {
      const pending = await LocalNotifications.getPending();
      if (pending.notifications.length > 0) {
        await LocalNotifications.cancel(pending);
      }
    } catch (err) {
      console.error('Error clearing notifications', err);
    }
  }

  private scheduleComeBackMessages() {
    if (localStorage.getItem('wasAdmin') === '1') {
      // console.log('Scheduling Month From Now');
      const monthFromNow = this.getDaysFromNow(30);
      this.create(
        100,
        'Ready to host again? Invite users from past Auctions, Copy Items, and be up in running in no time.',
        null,
        monthFromNow
      )
    } else {
      //  console.log('Scheduling Three From Now');
      const threeFromNow = this.getDaysFromNow(3);
      this.create(
        100,
        'Want to host your own Auction? You can use Bid Beacon to host your auctions too!',
        null,
        threeFromNow
      )
    }
  }

  private getDaysFromNow(daysFromNow: number) {
    const date = new Date();
    return new Date(date.setTime(date.getTime() + (daysFromNow * 24 * 60 * 60 * 1000)));
  }
}
